/** Checkout wizard step ids — keep in sync with getCheckoutSteps(). */
export const CHECKOUT_STEP = {
  DETAILS: 0,
  /** Age / declaration checkboxes — only used when required. */
  CONFIRM: 1,
  SUCCESS: 2,
};

export const CHECKOUT_STEP_MIN = CHECKOUT_STEP.DETAILS;
export const CHECKOUT_STEP_MAX = CHECKOUT_STEP.SUCCESS;

export const isValidCheckoutStep = (step) =>
  Number.isInteger(step) &&
  step >= CHECKOUT_STEP_MIN &&
  step <= CHECKOUT_STEP_MAX;

/**
 * Visible stepper labels. Confirm appears only when age-restricted products
 * require a declaration before payment. Payment is an inline page step
 * (Nedarim iframe stays on the page). Finish is the success screen.
 */
export const getCheckoutSteps = (requiresAgeConfirmation = false) =>
  requiresAgeConfirmation
    ? ["פרטי לקוח", "אישור", "תשלום", "סיום"]
    : ["פרטי לקוח", "תשלום", "סיום"];

/** @deprecated Prefer getCheckoutSteps(requiresAgeConfirmation). */
export const CHECKOUT_STEPS = getCheckoutSteps(true);

/**
 * Maps wizard state + payment step to a visible stepper index.
 * Payment is highlighted while the pay form or payment status overlay is open.
 */
export const getCheckoutStepDisplayIndex = (
  currentStep,
  { requiresAgeConfirmation = false, isPaymentOpen = false } = {},
) => {
  if (requiresAgeConfirmation) {
    if (currentStep === CHECKOUT_STEP.SUCCESS) return 3;
    if (isPaymentOpen) return 2;
    if (currentStep === CHECKOUT_STEP.CONFIRM) return 1;
    return 0;
  }

  if (currentStep === CHECKOUT_STEP.SUCCESS) return 2;
  if (isPaymentOpen) return 1;
  return 0;
};
